import React from 'react';

import { Layout } from 'antd';
import SiderLayout from './Sider';
import Header from './Header';
import Content from './Content';
import Footer from './Footer';

const ProtectedLayout = () => {
  return (
    <Layout className="min-h-screen">
      <SiderLayout />
      <Layout>
        <Header />
        <Content />
        {/* <Footer /> */}
      </Layout>
    </Layout>
  );
};

export default ProtectedLayout;
